// extracted by mini-css-extract-plugin
export default {"checkout":"CheckoutDetails_checkout__HA4BB","card":"CheckoutDetails_card__VIVGh","select":"CheckoutDetails_select__W4Kwp","card-details":"CheckoutDetails_card-details__usOEv"};